let triggered = false;

/* ===============================
 Shopify Live Chat Trigger
================================ */
function initShopifyChatTrigger() {
  const chatLinks = document.querySelectorAll('.open_livechat');

  chatLinks.forEach(link => {
    link.addEventListener('click', event => {
      event.preventDefault();

      const shopifyChat = document.getElementById('ShopifyChat');
      if (!shopifyChat || !shopifyChat.shadowRoot) return;

      const chatToggleButton =
        shopifyChat.shadowRoot.querySelector('button.chat-toggle');

      if (chatToggleButton) {
        chatToggleButton.click();
      }
    });
  });
}

/* ===============================
 Lazy Load Images & Pictures
================================ */
function lazyLoadPictures() {
  document.querySelectorAll('picture.lazy-load, img.lazy-load').forEach(el => {
    let img;

    if (el.tagName === 'PICTURE') {
      el.querySelectorAll('source').forEach(source => {
        if (source.dataset.srcset) {
          source.srcset = source.dataset.srcset;
          source.removeAttribute('data-srcset');
        }
      });
      img = el.querySelector('img');
    } else {
      img = el;
      if (img.dataset.srcset) {
        img.srcset = img.dataset.srcset;
        img.removeAttribute('data-srcset');
      }
    }

    if (!img || !img.dataset.src) return;

    const loader = document.createElement('div');
    loader.className = 'image-loader';
    img.parentElement.appendChild(loader);

    img.src = img.dataset.src;
    img.removeAttribute('data-src');
    img.classList.remove('lazy-load');

    img.onload = img.onerror = () => loader.remove();
  });
}

/* ===============================
 Lazy Load Videos
================================ */
function lazyLoadVideos() {
  document.querySelectorAll('video.lazy-load').forEach(video => {
    video.querySelectorAll('source').forEach(source => {
      if (source.dataset.src) {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      }
    });

    if (video.dataset.poster) {
      video.poster = video.dataset.poster;
      video.removeAttribute('data-poster');
    }

    video.load();
    video.classList.remove('lazy-load');
  });
}

/* ===============================
 Metafield Link Boxes Slider
================================ */
function initMetafieldLinkBoxesSlider() {
  document.querySelectorAll('.custom-link-boxes-wrapper').forEach(wrapper => {
    const prevBtn = wrapper.querySelector('.button-prev');
    const nextBtn = wrapper.querySelector('.button-next');
    if (!prevBtn || !nextBtn) return;

    wrapper.querySelectorAll(
      '.metafield-rich_text_field, .link-boxes-margin-container .link-boxes_wrapper'
    ).forEach(scrollContainer => {
      const items = scrollContainer.querySelectorAll('li, p');

      if (!items.length) {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
        return;
      }

      scrollContainer.style.overflowX = 'auto';
      scrollContainer.style.whiteSpace = 'nowrap';

      const scrollAmount = 200;

      const updateArrows = () => {
        const maxScroll =
          scrollContainer.scrollWidth - scrollContainer.clientWidth;

        prevBtn.style.display =
          scrollContainer.scrollLeft > 0 ? 'block' : 'none';

        nextBtn.style.display =
          scrollContainer.scrollLeft < maxScroll ? 'block' : 'none';
      };

      updateArrows();
      scrollContainer.addEventListener('scroll', updateArrows);
      window.addEventListener('resize', updateArrows);

      prevBtn.onclick = () =>
        scrollContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' });

      nextBtn.onclick = () =>
        scrollContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  });
}

/* ===============================
 Header Hover Dropdown
================================ */
function initHeaderMenuHover(selector = 'header-menu > details > summary') {
  if (!window.matchMedia('(hover: hover)').matches) return;

  document.querySelectorAll(selector).forEach(summary => {
    const details = summary.parentElement;
    
    summary.addEventListener('mouseenter', () => {
      details.open = true;
    });
    
    details.addEventListener('mouseleave', () => {
      details.open = false;
    });
  });
  const submenus = document.querySelectorAll('.grandchild__submenu');
  
  submenus.forEach(menu => {
    menu.addEventListener('toggle', () => {
      if (menu.open) {
        submenus.forEach(otherMenu => {
          if (otherMenu !== menu) {
            otherMenu.removeAttribute('open');
          }
        });
      }
    });
  });
}

function initProductSwipers() {
  if (!window.location.pathname.startsWith("/products")) return;

  document.querySelectorAll('.product-recommendations-swiper').forEach((slider) => {

    if (slider.swiper) return;

    new Swiper(slider, {
      slidesPerView: 'auto',
      spaceBetween: 20,

      loop: true,

      speed: 5000, // controls auto-scroll speed

      allowTouchMove: true,
      grabCursor: true,

      freeMode: {
        enabled: true,
        momentum: false,
      },

      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },

      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      },

      breakpoints: {
        320: {
          slidesPerView: 1.3,
        },
        768: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: 5,
        }
      }
    });
  });
}
/*------------FOR FOOTER QUICK LINKS COLLAPSABLE------------*/

  function setupFooterCollapse() {
    const blocks = document.querySelectorAll(".footer-block--menu");

    blocks.forEach(function (block, index) {
      const heading = block.querySelector(".footer-block--menu h2.footer-block__heading");
      const list = block.querySelector(".footer-block--menu .footer-block__details-content");

      if (heading && list) {
        // All blocks except the first: expanded by default
        if (index !== 0) {
          list.classList.add("active");
          heading.classList.add("is-open");
        }

        // All blocks (including first): allow toggle on click
        heading.addEventListener("click", function () {
          list.classList.toggle("active");
          heading.classList.toggle("is-open");
        });
      }
    });
  }


   /* =============================== Category Gallery Anim Inits ================================ */

function initCategoryGalleryMarquee() {
  if (typeof Swiper === 'undefined')
    return;
  const swiper = new Swiper('.mm-category-gallery__inner', {
    slidesPerView: 'auto',
    spaceBetween: 0,
    loop: true,
    // loopAdditionalSlides: 5,

    speed: 3000,
    allowTouchMove: true,

    freeMode: true,
    freeModeMomentum: false,

    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },

    grabCursor: true,
    watchOverflow: true,
  });

}

/* ===============================
 Top Trending Products
================================ */

function TrendingSwiper() {
  return new Swiper('.trending-products', {
    slidesPerView: 2,
    loop: true,
    spaceBetween: 16,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      640: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
    }
  });
  
}



/* ===============================
 Master Initializer
================================ */
function runAllDeferredFeatures() {
  if (triggered) return;
  triggered = true;

  initShopifyChatTrigger();
  lazyLoadPictures();
  lazyLoadVideos();
  initMetafieldLinkBoxesSlider();
  initHeaderMenuHover();
  initProductSwipers();
  setupFooterCollapse();
  initCategoryGalleryMarquee(); 
  TrendingSwiper();
}

/* ===============================
 Interaction-based Trigger
================================ */
(function () {
  ['scroll', 'mousemove', 'touchstart', 'keydown', 'click'].forEach(evt => {
    window.addEventListener(evt, runAllDeferredFeatures, {
      once: true,
      passive: true
    });
  });
  
  ['facet:update', 'theme:loading:end'].forEach(evt => {
    window.addEventListener(evt, () => {
      setTimeout(() => {
        triggered = false; // allow re-run
        runAllDeferredFeatures();
      }, 100);
    });
  });
})();

/* ===============================
 Initial Trigger
================================ */
initProductSwipers();
/* ===============================
 Delayed After-Load Trigger
================================ */
function onPageFullyLoaded(cb) {
  if (document.readyState === 'complete') {
    cb();
  } else {
    window.addEventListener('load', cb);
  }
}

onPageFullyLoaded(function () {
  initProductSwipers();
});


